import { createFileRoute } from '@tanstack/react-router';

import { useOrgId } from '@/features/org/api';
import { usePageState } from '@/lib/page-state';
import { CompetitorsScreen, type CompetitorsSearch } from '@/screens/creative/CompetitorsScreen';

export const Route = createFileRoute('/_app/creative/competitors')({
  component: CompetitorsPage,
});

const INITIAL: CompetitorsSearch = {};

/** The brand and the tab are page state kept in memory per org, not URL params. */
function CompetitorsPage() {
  const orgId = useOrgId();
  const [search, patch] = usePageState(`${orgId}/competitors/nav`, INITIAL);
  return <CompetitorsScreen search={search} onSearch={patch} />;
}
